import * as types from './mutation-types';
import router from '@/router';
import getKey from '@/clir/utils/getKey';
import generateUid from '@/clir/utils/generateUid';

const parseUserResponse = (user) => {
    const parsedUser = {
        id: user.profile.uid,
        profil: user.profile,
    };
    parsedUser.profil.sn = user.profile.family_name;
    parsedUser.profil.givenName = user.profile.given_name;
    return parsedUser;
};

const saveRoute = (route) => {
    const fullPath = getKey(route, 'fullPath', null) || getKey(router, 'history.current.fullPath', '/');
    if (!fullPath.toLowerCase().includes('login')) {
        sessionStorage.setItem('routeClir', fullPath);
    }
};

export default {
    reset: ({ commit }) => {
        commit(types.SET_TOKEN, '');
    },
    getMe: async ({ getters }) => {
        const manager = getters.mgr;
        try {
            let me = await manager.getUser();
            if (me === null) {
                me = await manager.signinRedirectCallback();
            }
            const user = parseUserResponse(me);
            return user;
        } catch (e) {
            throw e;
        }
    },
    authMe: async ({ dispatch, commit, getters }, data) => {
        const manager = getters.mgr;
        saveRoute(data);
        try {
            let me = await manager.getUser();
            if (me === null) {
                me = await manager.signinRedirectCallback();
            }
            const user = parseUserResponse(me);
            await dispatch('user/setMe', user, { root: true });
            const token = await manager.getAcessToken();
            commit(types.SET_TOKEN, token);
            return true;
        } catch (e) {
            return false;
        }
    },
    login: async ({ getters }) => {
        try {
            await getters.mgr.signIn();
            return;
        } catch (e) {
            throw (e);
        }
    },
    logout: async ({ getters }) => {
        try {
            await getters.mgr.signOut();
            return;
        } catch (e) {
            throw (e);
        }
    },
    getHeaders: ({ getters, rootGetters }) => {
        const isAuthenticated = rootGetters[`user/isAuthenticated`];
        if (isAuthenticated) {
            const correlation = `${process.env.VUE_APP_APIM_CORRELATION_ID_VALUE_PREFIX}${generateUid()}`;
            return {
                'Authorization': `Bearer ${getters.token}`,
                'X-Correlation-ID': correlation,
            }
        }
        return {}
    }
};